import React from 'react';
import Editor from '@monaco-editor/react';
import { Spinner } from 'reactstrap';

const UiSchemaForm = ({ value = '{}', onChange }) => {
    const handleChange = (formData) => {
        console.log("Form data changing:", formData);
        onChange({ json: formData });
    };

    return (
        <Editor
            height="200px"
            theme="vs-dark"
            language="json"
            loading={<Spinner />}
            value={value}
            onChange={handleChange}
        />
    );
};

export default UiSchemaForm;
